// Subscription plans for professionals on Profind.ca

export const subscriptionPlans = [
  {
    id: 'free',
    name: 'Free',
    price: 0,
    billingPeriod: 'month',
    description: 'Get started with basic features',
    features: [
      'Basic profile listing',
      'Up to 5 quote requests per month',
      'Standard search placement',
      'Email notifications',
      'Profile analytics'
    ],
    limitations: [
      'Limited visibility in search',
      'No featured placement',
      'Basic support only'
    ],
    leadCost: 25, // Cost per lead in CAD
    color: 'gray'
  },
  {
    id: 'professional',
    name: 'Professional',
    price: 299,
    billingPeriod: 'year',
    monthlyEquivalent: 24.92,
    popular: true,
    description: 'Perfect for growing businesses',
    features: [
      'Enhanced profile with photos',
      'Unlimited quote requests',
      'Priority search placement',
      'Instant email & SMS notifications',
      'Advanced analytics dashboard',
      'Customer review management',
      'Verified badge',
      'Business hours display'
    ],
    limitations: [],
    leadCost: 18, // Discounted cost per lead in CAD
    savings: 'Save $100/year vs monthly',
    color: 'orange'
  },
  {
    id: 'premium',
    name: 'Premium',
    price: 599,
    billingPeriod: 'year',
    monthlyEquivalent: 49.92,
    description: 'For established pros who want maximum exposure',
    features: [
      'Everything in Professional, plus:',
      'Featured placement in search results',
      'Homepage featured section',
      'Category page top placement',
      'Priority customer support',
      'Dedicated account manager',
      'Custom branding options',
      'API access for integrations',
      'Advanced marketing tools',
      'Competitor insights'
    ],
    limitations: [],
    leadCost: 15, // Best cost per lead in CAD
    savings: 'Save $200/year + lowest lead costs',
    color: 'blue'
  }
];

export const leadPricing = {
  'Plumbing': { min: 18, max: 35 },
  'Electrical': { min: 20, max: 40 },
  'Roofing': { min: 45, max: 85 },
  'HVAC': { min: 25, max: 50 },
  'Snow Removal': { min: 15, max: 25 },
  'Landscaping': { min: 20, max: 40 },
  'House Painting': { min: 30, max: 60 },
  'Cleaning': { min: 15, max: 30 },
  'Handyman': { min: 15, max: 25 },
  'Renovation': { min: 50, max: 100 },
  'Pest Control': { min: 20, max: 35 },
  'Garage Doors': { min: 25, max: 45 }
};

export const getPlanById = (planId) => {
  return subscriptionPlans.find(plan => plan.id === planId) || subscriptionPlans[0];
};

export const getLeadPriceForCategory = (category, planId = 'free') => {
  const pricing = leadPricing[category] || { min: 15, max: 30 };
  const plan = getPlanById(planId);
  
  // Apply plan discount
  const basePrice = (pricing.min + pricing.max) / 2;
  const discount = plan.leadCost / 25; // Relative to free plan
  
  return Math.round(basePrice * discount);
};

export const calculateMonthlyLeadCost = (leadsPerMonth, planId, category) => {
  const leadPrice = getLeadPriceForCategory(category, planId);
  return leadsPerMonth * leadPrice;
};
